import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

// TODO: (standardize-document-content): 추후 적절한 타입 위치 찾기
interface Terms {
  id: string;
  version: string;
  link: string;
  startedAt: string;
  endedAt: string | null;
}

interface NewDocumentsTermsResponse {
  termsOfUse: Terms;
  privacyPolicy: Terms | null;
}
interface DocumentsTermsResponse {
  result: {
    privacyPolicy: {
      link: string;
      privacyPolicyId: string;
      startedAt: string;
      version: string;
    } | null;
    termOfUse: {
      link: string;
      startedAt: string;
      termOfUseId: string;
      version: string;
    };
  };
}

const convertToDeprecatedResponse = (
  response: NewDocumentsTermsResponse
): DocumentsTermsResponse => {
  return {
    result: {
      privacyPolicy: response.privacyPolicy
        ? {
            privacyPolicyId: response.privacyPolicy.id,
            link: response.privacyPolicy.link,
            startedAt: response.privacyPolicy.startedAt,
            version: response.privacyPolicy.version,
          }
        : null,
      termOfUse: {
        link: response.termsOfUse.link,
        startedAt: response.termsOfUse.startedAt,
        termOfUseId: response.termsOfUse.id,
        version: response.termsOfUse.version,
      },
    },
  };
};

/**
 * GET 문서에 적용된 약관 조회
 * @deprecated Endpoint response is modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#02b76ccc068a491e98985409e2074f95
 */
export function getDocumentsTerms({
  workspaceId,
  documentId,
}: {
  workspaceId: string;
  documentId: string;
}): Promise<{
  privacyPolicyURL: string | null;
  termOfUseURL: string;
}> {
  return requestApi<NewDocumentsTermsResponse>({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/terms`),
    method: 'GET',
    credentials: true,
  }).then((response) => {
    const { privacyPolicy, termOfUse } = convertToDeprecatedResponse(response.data).result;
    return {
      privacyPolicyURL: privacyPolicy?.link ?? null,
      termOfUseURL: termOfUse.link,
    };
  });
}
